/**
 * Created by sange on 30/10/2017.
 */
import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { of } from 'rxjs/observable/of'
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators'
import { JeanService } from '../../../../api/api/services/jean.service'
import { ChatState } from '../../../../chat/store/reducers/'

import { AppState } from '../../../../store/'
import * as App from '../../../../store/actions/app.actions'
import * as userSelectors from '../../../auth/store/selectors/user.selectors'
import * as ConvTeams from '../actions/conversation-team.actions'

@Injectable()
export class ConversationTeamEffects {

  constructor(private actions$: Actions,
              private store: Store<ChatState>,
              private rootStore: Store<AppState>,
              private jeanService: JeanService) {
  }

  @Effect()
  loadConversationTeams$ = this.actions$.pipe(
    ofType(ConvTeams.LOAD_CONVERSATION_TEAMS),
    switchMap(_ =>
      this.jeanService.GetVendorConversationsTeams({version: '1', limit: 0}).pipe(
        withLatestFrom(this.rootStore.select(userSelectors.getAuthUser)),
        map(([teams, user]) => ({teams, user})),
        map(({teams, user}) => new ConvTeams.LoadConversationTeamsSuccess({teams: teams.items, me: user})),
        catchError(error => of(new App.ApiCallFailure({
          title: 'Error',
          msg: 'Could not load teams'
        }))))))
}



// WEBPACK FOOTER //
// ./src/app/shared/team/store/effects/conversation-team.effects.ts